import { AutopilotTaskDto } from '@urbanx/agx.activities.client'
import { JSX } from 'react'
import { BlockerLayout } from './BlockerLayout'

interface GenericPendingBlockerProps {
  task: AutopilotTaskDto
  onTasksInvalidated?: () => void | Promise<void>
}

export const GenericPendingBlocker = ({
  task,
  onTasksInvalidated,
}: GenericPendingBlockerProps): JSX.Element => {
  return (
    <BlockerLayout
      task={task}
      title="Task Pending"
      description="This task is waiting for a previous step to be completed."
      onTasksInvalidated={onTasksInvalidated}
    />
  )
}
